export const EAppPath = {
	DASHBOARD: '/',

	SIGN_UP: '/signup',
	LOG_IN: '/login',

	SETTINGS: '/settings',

	EXPENSES: '/expenses',

	CATEGORIES: '/categories',
	CATEGORIES_VIEW: '/categories/:id',

	VENUES: '/venues',
	VENUES_CREATE: '/venues/new',
	VENUES_VIEW: '/venues/:id',
} as const;
